import { PerfilSeccionId } from '../data/perfil-microempresario.content';
import { PerfilSegmento } from './segmento/perfil-segmento.util';
import { segmentoToTipoPersonaApi } from './documentos/perfil-documentos.util';

/** Tipologías de catálogo `tiposDocumentos/perfil/{tipo}`. */
export type PerfilTipoDocumentosApi = 'express' | 'natural' | 'juridica';

export function isPerfilJuridica(
  tipoPersona: string | null | undefined
): boolean {
  return tipoPersona === 'juridica';
}

/** Orden hub / secuencialidad. PJ: 2 secciones (empresa=sobre-ti, ingresos). */
export function perfilSeccionOrder(
  tipoPersona: string | null | undefined
): PerfilSeccionId[] {
  if (isPerfilJuridica(tipoPersona)) {
    return ['sobre-ti', 'sobre-ingresos'];
  }
  return ['sobre-ti', 'sobre-negocio', 'sobre-ingresos'];
}

/**
 * Catálogo docs: PJ → `juridica`; PN → express|natural según segmento.
 */
export function resolveTipoDocumentosPerfilApi(
  tipoPersona: string | null | undefined,
  segmento: PerfilSegmento
): PerfilTipoDocumentosApi {
  if (isPerfilJuridica(tipoPersona)) {
    return 'juridica';
  }
  return segmentoToTipoPersonaApi(segmento);
}

/** Endpoint `guardarDatos/{endpoint}`. */
export function resolveSaveSolicitudEndpoint(
  tipoPersona: string | null | undefined
): 'natural' | 'juridico' {
  return isPerfilJuridica(tipoPersona) ? 'juridico' : 'natural';
}
